const { SOLUTION_DEFAULT, VALUE_PLATFORM } = require("./common/LocalConst");
const {
  default: localStorageService,
} = require("./services/localStorageService");

const getSystemConfig = (key) => {
  const data = localStorageService.getItem("sysConfig") || {};
  if (data === null || data === undefined) return null;
  return data?.[key] !== null || data?.[key] !== undefined ? data?.[key] : null;
};

const getPrintFormCode = (key) => {
  const data = localStorageService.getItem("PRINT_FORM_CODE") || {};

  if (data === null || data === undefined) return null;
  return data?.[key] !== null || data?.[key] !== undefined ? data?.[key] : null;
};

const APPLICATION_PATH = "/";
module.exports = {
  AUTH_MODE: window.Configs.AUTH_MODE || "Keycloak",
  ROOT_PATH: window.Configs.ROOT_PATH || APPLICATION_PATH,
  ACTIVE_LAYOUT: window.Configs.ACTIVE_LAYOUT || "layout1", //layout1 = vertical, layout2=horizontal
  API_ENPOINT:
    window.Configs.API_ENPOINT || "https://test.globits.net:8080/api",
  API_EN_POINT:
    window.Configs.API_EN_POINT || "https://test.globits.net:8080/api",
  API_EN_POINT_STORE:
    window.Configs.API_EN_POINT_STORE ||
    "https://store-api.smarthospital247.com/api",
  API_EN_POINT_CRM:
    window.Configs.API_EN_POINT_CRM ||
    "https://crm-api.smarthospital247.com/api",
  LOGIN_PAGE: APPLICATION_PATH + "session/signin", //Nếu là Spring
  HOME_PAGE: APPLICATION_PATH + "module", //Nếu là Spring
  STORE_URL:
    window.Configs.STORE_URL || "https://home-store.globits.net/module",
  ADDRESS:
    getSystemConfig("ADDRESS") ||
    window.Configs.ADDRESS_HOSPITAL ||
    "Từ Sơn, Bắc Ninh",
  PHONE_NUMBER: getSystemConfig("PHONE_NUMBER") || window.Configs.PHONE_NUMBER,
  HOTLINE: getSystemConfig("HOTLINE") || window.Configs.HOTLINE,
  REQUEST_NUMBER_PATH: window.Configs.REQUEST_NUMBER_PATH,
  RESULT_TEST_PATH: window.Configs.RESULT_TEST_PATH,
  TICKET_PATH: window.Configs.TICKET_PATH,
  TICKET_COMMENT_PATH: window.Configs.TICKET_COMMENT_PATH,
  CONSUMER_ID: getSystemConfig("CONSUMER_ID") || window.Configs.CONSUMER_ID,
  ACQUIER_ID: getSystemConfig("ACQUIER_ID") || window.Configs.ACQUIER_ID,
  ORG_NAME: getSystemConfig("ORG_NAME") || window.Configs.ORG_NAME,
  ORG_SLOGAN: getSystemConfig("ORG_SLOGAN") || window.Configs.ORG_SLOGAN,
  DOCTOR: window.Configs.DOCTOR,
  ADDRESS_HOSPITAL:
    getSystemConfig("ADDRESS_HOSPITAL") || window.Configs.ADDRESS_HOSPITAL,
  ALERT_AUTO: window.Configs.ALERT_AUTO,
  LOGO: getSystemConfig("LOGO"),
  IMAGE_SIZE: Number(
    getSystemConfig("IMAGE_SIZE") || window.Configs.IMAGE_SIZE
  ),
  UPLOAD_NUMBER_IMG: Number(
    getSystemConfig("UPLOAD_NUMBER_IMG") || window.Configs.UPLOAD_NUMBER_IMG
  ),
  FORMAT_MONEY_NUMBER: Number(
    getSystemConfig("FORMAT_MONEY_NUMBER") || window.Configs.FORMAT_MONEY_NUMBER
  ),
  VALIDATE_PHONENUMBER: Boolean(
    getSystemConfig("VALIDATE_PHONENUMBER") ??
    window.Configs.VALIDATE_PHONENUMBER
  ),
  PAGE_SIZE_DEFAULT:
    getSystemConfig("PAGE_SIZE_DEFAULT") || window.Configs.PAGE_SIZE_DEFAULT,
  SHOW_COMPANY:
    getSystemConfig("SHOW_COMPANY") || window.Configs.SHOW_COMPANY || false,
  COMPANY_NAME:
    getSystemConfig("COMPANY_NAME") ||
    window.Configs.COMPANY_NAME ||
    "CÔNG TY CP SỨC KHỎE & MÔI TRƯỜNG HÀ NỘI",
  APPOINTMENT_PATH: window.Configs.APPOINTMENT_PATH,
  SYNC_DEPAERTMENT_TYPE_CODE:
    getSystemConfig("SYNC_DEPAERTMENT_TYPE_CODE") ||
    window.Configs.SYNC_DEPAERTMENT_TYPE_CODE,

  REGISTER_SERVICE_SIGNLE:
    getSystemConfig("REGISTER_SERVICE_SIGNLE") ||
    window.Configs.REGISTER_SERVICE_SIGNLE ||
    false,

  POSITION_CODES:
    getSystemConfig("POSITION_CODES") || window.Configs.POSITION_CODES || [],
  CUSTOMER_SOURCE_WALK_IN_CODE:
    getSystemConfig("CUSTOMER_SOURCE_WALK_IN_CODE") ||
    window.Configs.CUSTOMER_SOURCE_WALK_IN_CODE ||
    "NKV_VL",
  //  code customer source walk in
  POSITION_TELESALE:
    getSystemConfig("POSITION_TELESALE") ||
    window.Configs.POSITION_TELESALE ||
    "CD_0081",
  POSITION_CONSULTANT:
    getSystemConfig("POSITION_CONSULTANT") ||
    window.Configs.POSITION_CONSULTANT ||
    "CD_0085",
  TREATMENT_PLAN_CARD_PRINT_LOGO:
    getSystemConfig("TREATMENT_PLAN_CARD_PRINT_LOGO") ||
    window.Configs.TREATMENT_PLAN_CARD_PRINT_LOGO,
  DEFAULT_REVENUE_ALLOCATION:
    getSystemConfig("DEFAULT_REVENUE_ALLOCATION") ||
    window.Configs.DEFAULT_REVENUE_ALLOCATION ||
    100,
  LIST_DEFAULT_SOURCE_FOR_COMPANION:
    getSystemConfig("LIST_DEFAULT_SOURCE_FOR_COMPANION") ||
    window.Configs.LIST_DEFAULT_SOURCE_FOR_COMPANION ||
    [],

  POSITION_CODES_TREATMENT:
    getSystemConfig("POSITION_CODES_TREATMENT") ||
    window.Configs.POSITION_CODES_TREATMENT ||
    [],

  CHOOSE_PATIENT_TYPE_SERVICE_ADVISE:
    getSystemConfig("CHOOSE_PATIENT_TYPE_SERVICE_ADVISE") ||
    window.Configs.CHOOSE_PATIENT_TYPE_SERVICE_ADVISE ||
    false,

  MULTIPLE_UPLOAD_IMAGES_TREATMENT:
    getSystemConfig("MULTIPLE_UPLOAD_IMAGES_TREATMENT") ||
    window.Configs.MULTIPLE_UPLOAD_IMAGES_TREATMENT ||
    true, // cho phép upload nhiều ảnh trước và sau điều trị

  UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER:
    getSystemConfig("UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER") ||
    window.Configs.UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER, // cho phép upload bao nhiêu ảnh trước và sau điều trị
  CRM_URL:
    getSystemConfig("CRM_URL") ||
    window.Configs.CRM_URL ||
    "https://crm.lagroup.vn",
  HUMANRESOURCES_URL:
    getSystemConfig("HUMANRESOURCES_URL") ||
    window.Configs.HUMANRESOURCES_URL ||
    "https://uat.lagroup.vn",
  OPERATE_URL:
    getSystemConfig("OPERATE_URL") ||
    window.Configs.OPERATE_URL ||
    "https://ic.smarthospital247.com",
  SUPERSET_URL:
    getSystemConfig("SUPERSET_URL") ||
    window.Configs.SUPERSET_URL ||
    "https://superset.lagroup.vn/",
  CHECK_LENGTH_SEARCH_CUSTOMER:
    getSystemConfig("CHECK_LENGTH_SEARCH_CUSTOMER") ||
    window.Configs.CHECK_LENGTH_SEARCH_CUSTOMER ||
    6, // check độ dài 6 kí tự thì mới cho tìm kiếm tại ô input header
  POSITION_KTVS:
    getSystemConfig("POSITION_KTVS") || window.Configs.POSITION_KTVS || [],
  // danh sách mã ktv

  FORMAT_DECIMAL_NUMBER:
    getSystemConfig("FORMAT_DECIMAL_NUMBER") ||
    window.Configs.FORMAT_DECIMAL_NUMBER ||
    2, // làm tròn số sau thập phân,
  DISPLAY_ALL_SERVICE_TAB:
    getSystemConfig("DISPLAY_ALL_SERVICE_TAB") ||
    window.Configs.DISPLAY_ALL_SERVICE_TAB ||
    false,
  ASYNC_DATA_CRM_PATIENT:
    getSystemConfig("ASYNC_DATA_CRM_PATIENT") ||
    window.Configs.ASYNC_DATA_CRM_PATIENT ||
    false,
  ENABLE_HISTORY: Boolean(
    getSystemConfig("ENABLE_HISTORY") ?? window.Configs.ENABLE_HISTORY
  ),
  CHECK_TOUR:
    getSystemConfig("CHECK_TOUR") || window.Configs.CHECK_TOUR || false,

  DISPLAY_PROMOTION:
    getSystemConfig("DISPLAY_PROMOTION") ||
    window.Configs.DISPLAY_PROMOTION ||
    false,

  // check số tiền được giảm trong thanh toán dịch vụ sản phẩm
  CHECK_DISCOUNT:
    getSystemConfig("CHECK_DISCOUNT") || window.Configs.CHECK_DISCOUNT || false,
  SEARCH_ELASTIC:
    getSystemConfig("SEARCH_ELASTIC") || window.Configs.SEARCH_ELASTIC || false,

  DOCTOR_POSITION_CODES:
    getSystemConfig("DOCTOR_POSITION_CODES") ||
    window.Configs.DOCTOR_POSITION_CODES ||
    [],

  TECHNICIAN_POSITION_CODES:
    getSystemConfig("TECHNICIAN_POSITION_CODES") ||
    window.Configs.TECHNICIAN_POSITION_CODES ||
    [],

  NURSE_POSITION_CODES:
    getSystemConfig("NURSE_POSITION_CODES") ||
    window.Configs.NURSE_POSITION_CODES ||
    [],

  TELESALE_POSITION_CODES:
    getSystemConfig("TELESALE_POSITION_CODES") ||
    window.Configs.TELESALE_POSITION_CODES ||
    [],

  PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT:
    getSystemConfig("PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT") ||
    window.Configs.PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT, //  cho phép upload bao nhiều hình ở phiêu chi
  KTV_HAS_ASSIGN_TREATMENT:
    getSystemConfig("KTV_HAS_ASSIGN_TREATMENT") ||
    window.Configs.KTV_HAS_ASSIGN_TREATMENT ||
    false, // cho phép ktv được chỉ định
  GET_LEAD_REACTION_BY_PHONE:
    getSystemConfig("GET_LEAD_REACTION_BY_PHONE") ||
    window.Configs.GET_LEAD_REACTION_BY_PHONE ||
    false, // lấy tương tác theo SKH
  USE_DIRECT_COMPANION: Boolean(
    getSystemConfig("USE_DIRECT_COMPANION") ?? window.Configs.USE_DIRECT_COMPANION ?? true
  ), // true: dùng "Có người đi cùng" + nhập SĐT; false: dùng "Có người đi kèm"
  CHECKIN_IN_FORM_PATIENT:
    getSystemConfig("CHECKIN_IN_FORM_PATIENT") ||
    window.Configs.CHECKIN_IN_FORM_PATIENT ||
    false, // check in trong form KH

  CHECK_LENGTH_PHONE_SEARCH:
    getSystemConfig("CHECK_LENGTH_PHONE_SEARCH") ||
    window.Configs.CHECK_LENGTH_PHONE_SEARCH ||
    10, // kiểm tra độ dài sdt rồi mới cho search

  VALIDATE_PAYMENT_TREATMENT:
    getSystemConfig("VALIDATE_PAYMENT_TREATMENT") ||
    window.Configs.VALIDATE_PAYMENT_TREATMENT ||
    true, // check validate trong chỉ định,thanh toán đủ mới cho
  SHOW_CHART_REPORT_SOURCE_SERVICE:
    getSystemConfig("SHOW_CHART_REPORT_SOURCE_SERVICE") ||
    window.Configs.SHOW_CHART_REPORT_SOURCE_SERVICE ||
    true, // ẩn chart dv
  SHOW_CHART_REPORT_SOURCE_CUSTOMER:
    getSystemConfig("SHOW_CHART_REPORT_SOURCE_CUSTOMER") ||
    window.Configs.SHOW_CHART_REPORT_SOURCE_CUSTOMER ||
    true, // ẩn chart kh
  CHECK_DATE_REPORT:
    getSystemConfig("CHECK_DATE_REPORT") ||
    window.Configs.CHECK_DATE_REPORT ||
    31, // Check ngày ở báo cáo k cho vượt quá 1 tháng

  // chỉ đọc từ cấu hình client
  PAYMENT_METHOD_LIMITS:
    // getSystemConfig("PAYMENT_METHOD_LIMITS") ||
    window.Configs.PAYMENT_METHOD_LIMITS || [], // Mảng mã các phương thức thanh toán cần loại bỏ (ví dụ: ["CK", "TM"])

  SHOW_UPDATE_TOUR_AND_IMAGE_TREATMENT:
    getSystemConfig("SHOW_UPDATE_TOUR_AND_IMAGE_TREATMENT") ||
    window.Configs.SHOW_UPDATE_TOUR_AND_IMAGE_TREATMENT ||
    false, // chức năng cập nhật nhiều dv trong điều trị
  APPOINTMENT_TYPE_KTV_SELECT:
    getSystemConfig("APPOINTMENT_TYPE_KTV_SELECT") ||
    window.Configs.APPOINTMENT_TYPE_KTV_SELECT ||
    true, // mặc định ktv đặt lịch là loại điều trị và disabled

  SELECT_ALL_ITEM_FEE:
    getSystemConfig("SELECT_ALL_ITEM_FEE") ||
    window.Configs.SELECT_ALL_ITEM_FEE ||
    true, // mặc định chọn hết các item trong popup thu ngân
  SHOW_EXPENSE_OCCURRED:
    getSystemConfig("SHOW_EXPENSE_OCCURRED") ||
    window.Configs.SHOW_EXPENSE_OCCURRED ||
    false, // Thông tin "Đã phát sinh" của kh
  PERMISSION_ROLE_HIS_PAYMENT:
    getSystemConfig("PERMISSION_ROLE_HIS_PAYMENT") ||
    window.Configs.PERMISSION_ROLE_HIS_PAYMENT ||
    true, // cho phép role his_payment này sửa giá

  PROMOTION_CODES:
    getSystemConfig("PROMOTION_CODES") || window.Configs.PROMOTION_CODES || [],

  PROMOTION_DEFAULT_CODE:
    getSystemConfig("PROMOTION_DEFAULT_CODE") ||
    window.Configs.PROMOTION_DEFAULT_CODE ||
    "TU_VAN_VIEN_GIAM",

  SHOW_LOYALTY_TAB:
    getSystemConfig("SHOW_LOYALTY_TAB") ||
    window.Configs.SHOW_LOYALTY_TAB ||
    true, // cho phép hiện tab tích điểm

  REQUIRED_CTKM_DISCOUNT:
    getSystemConfig("REQUIRED_CTKM_DISCOUNT") ||
    window.Configs.REQUIRED_CTKM_DISCOUNT ||
    true, // bắt buộc chọn ctkm mới cho giảm giá

  REQUIRED_CTKM:
    getSystemConfig("REQUIRED_CTKM") || window.Configs.REQUIRED_CTKM || true, // bắt buộc chọn ctkm

  LOGOUT_LOG_BROWSER:
    getSystemConfig("LOGOUT_LOG_BROWSER") ||
    window.Configs.LOGOUT_LOG_BROWSER ||
    false, // tự động logout khi mà trình duyệt bị f12

  VALIDATE_MAXIMUM_EXPORT_CURRENT_QUANTITY:
    getSystemConfig("VALIDATE_MAXIMUM_EXPORT_CURRENT_QUANTITY") ||
    window.Configs.VALIDATE_MAXIMUM_EXPORT_CURRENT_QUANTITY ||
    true, //bắt buộc số lượng xuất không được vượt qua tồn

  DEFAULT_GET_WARRANTY:
    getSystemConfig("DEFAULT_GET_WARRANTY") ||
    window.Configs.DEFAULT_GET_WARRANTY ||
    true, //mặc định lấy ra thông tin bảo hành khi đăng kí ,đổi

  // Trạng thái nghỉ việc để search staff khi thanh toán
  EXCLUDE_QUIT_STAFF:
    getSystemConfig("EXCLUDE_QUIT_STAFF") ||
    window.Configs.EXCLUDE_QUIT_STAFF ||
    "DA_NGHI_VIEC", // giá trị mặc định

  REQUIRED_PERFORM_ROOM_IN_TREATMENT:
    getSystemConfig("REQUIRED_PERFORM_ROOM_IN_TREATMENT") ||
    window.Configs.REQUIRED_PERFORM_ROOM_IN_TREATMENT ||
    true, //bắt buộc chọn phòng khi điều trị

  // Ẩn thông tin số điện thoại
  HIDE_PHONE_NUMBER:
    getSystemConfig("HIDE_PHONE_NUMBER") ||
    window.Configs.HIDE_PHONE_NUMBER ||
    true, // giá trị mặc định CheckInDependent
  SOURCE_DEPENDENT_PLATFORM:
    getSystemConfig("SOURCE_DEPENDENT_PLATFORM") ||
    window.Configs.SOURCE_DEPENDENT_PLATFORM ||
    [], // nguồn đi chung
  // cho tính năng đổi mk
  ACCEPT_CHANGE_PASSWORD:
    getSystemConfig("ACCEPT_CHANGE_PASSWORD") ||
    window.Configs.ACCEPT_CHANGE_PASSWORD ||
    false, //
  IS_CHECK_MANY_CHECKIN_ON_DAY:
    getSystemConfig("IS_CHECK_MANY_CHECKIN_ON_DAY") ||
    window.Configs.IS_CHECK_MANY_CHECKIN_ON_DAY ||
    true, // cho checkin nhiều lần trong ngày
  CHECK_ELASTIC_LEADS:
    getSystemConfig("CHECK_ELASTIC_LEADS") ||
    window.Configs.CHECK_ELASTIC_LEADS ||
    true, // gọi thêm api search leads bên crm
  REQUIRE_CONSULTANT_CHECKIN:
    getSystemConfig("REQUIRE_CONSULTANT_CHECKIN") ||
    window.Configs.REQUIRE_CONSULTANT_CHECKIN ||
    false,// Bắt buộc chọn nhân viên tư vấn khi check-in
  ENABLE_QR_SURVEY:
    getSystemConfig("ENABLE_QR_SURVEY") ||
    window.Configs.ENABLE_QR_SURVEY ||
    false,
  QR_SURVEY_URL:
    getSystemConfig("QR_SURVEY_URL") ||
    window.Configs.QR_SURVEY_URL ||
    "",
  QR_SURVEY_NOTE:
    getSystemConfig("QR_SURVEY_NOTE") ||
    window.Configs.QR_SURVEY_NOTE ||
    "",
  QR_SURVEY_PARAMS:
    getSystemConfig("QR_SURVEY_PARAMS") ||
    window.Configs.QR_SURVEY_PARAMS ||
    [],
  LIST_CODE_SOURCE_CTV:
    getSystemConfig("LIST_CODE_SOURCE_CTV") ||
    window.Configs.LIST_CODE_SOURCE_CTV ||
    [],
  LIST_CODE_SOURCE_DI_CHUNG:
    getSystemConfig("LIST_CODE_SOURCE_DI_CHUNG") ||
    window.Configs.LIST_CODE_SOURCE_DI_CHUNG ||
    [],
  PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE:
    getSystemConfig("PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE") ||
    window.Configs.PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE ||
    [],
  FEE_VOUCHER_PRINT_VERSION:
    getSystemConfig("FEE_VOUCHER_PRINT_VERSION") ||
    window.Configs.FEE_VOUCHER_PRINT_VERSION ||
    "v1",

};
